import { createRouter, createWebHashHistory } from 'vue-router';
import LandingPage from '@/pages/LandingPage';
import NotFound from '@/pages/NotFound';
import StudyOverview from '@/pages/StudyOverview.vue';
import { APP_ID } from '@/main';

const baseRoutes = [
    {
        path: '/',
        name: 'LandingPage',
        component: LandingPage,
    },
    {
        path: '/study/:studyId',
        name: 'StudyOverview',
        component: StudyOverview,
    },
    {
        path: '/:catchAll(.*)',
        name: 'Not Found',
        component: NotFound
    }
];

const router = createRouter({
    history: createWebHashHistory(),
    routes: baseRoutes,
    base: './',

    scrollBehavior() {
        document.getElementById(APP_ID).scrollIntoView();
    }
});

export default router;
